var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoFill = function SvgInfoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.275 11.275a1.025 1.025 0 0 1-2.05 0V6.15a1.025 1.025 0 0 1 2.05 0v5.125Zm-1.025 4.1a1.025 1.025 0 1 1 0-2.05 1.025 1.025 0 0 1 0 2.05ZM10.25 0C4.589 0 0 4.589 0 10.25S4.589 20.5 10.25 20.5 20.5 15.911 20.5 10.25 15.911 0 10.25 0Z",
    fill: "#D1392B"
  })));
};
export default SvgInfoFill;